import {
  createRichBlock,
  RichBlockProps,
} from "@resource/atlas/content-editor/__utils/rich-blocks";
import { useMemo } from "react";
import {
  DEFAULT_DATA,
  RICH_BLOCK_NAME,
  ShareAvailabilityData,
} from "shared/guide-content/rich-blocks/share-availability";

import { useShareAvailability } from "./context";
import { ShareAvailabilityDisplay } from "./share-availability-display";
import { useIsRevision, useSelectionsByCandidate } from "./utils";

// component
// ---------

function ShareAvailabilityComponent({
  data,
  ConfigMenu,
}: RichBlockProps<ShareAvailabilityData>) {
  const { getCandidateAvailabilityById, loading, isMostRecent } =
    useShareAvailability();
  const candidateAvailability = getCandidateAvailabilityById(
    data.candidateAvailabilityId
  );
  const selectionsByCandidate = useSelectionsByCandidate({
    loading,
    candidateAvailability,
    availabilitiesFromLexical: data.availabilities,
  });

  const isMostRecentAvailability = useMemo(
    () => isMostRecent(data.candidateAvailabilityId),
    [isMostRecent, data.candidateAvailabilityId]
  );

  const isRevisedAvailability = useIsRevision({
    candidateAvailabilityId: data.candidateAvailabilityId,
    candidateAvailability,
  });

  return (
    <>
      <ConfigMenu />
      <ShareAvailabilityDisplay
        title={candidateAvailability?.title ?? data.title}
        availabilities={selectionsByCandidate}
        isMostRecent={isMostRecentAvailability}
        isRevision={isRevisedAvailability}
      />
    </>
  );
}

// block
// -----

export const {
  $createShareAvailabilityNode,
  $isShareAvailabilityNode,
  INSERT_SHARE_AVAILABILITY_COMMAND,
  ShareAvailabilityNode,
  ShareAvailabilityPlugin,
  shareAvailabilityModule,
} = createRichBlock({
  name: RICH_BLOCK_NAME,
  defaultData: DEFAULT_DATA,
  RenderComponent: ShareAvailabilityComponent,
});
